exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div__Box {\n  border-radius: 40px;\n  background-color: var(--WHITE);\n  padding: 1em;\n}\n", ""]);

// exports
